import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { FILTER_ACTIVE_CLASS, useFilterHighlight } from "@/components/molecules/FilterBar";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: ReadonlyArray<{ value: string; label: string }>;
  placeholder?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, placeholder, className, value, ...rest },
  ref,
) {
  const filterActive = useFilterHighlight(value != null && String(value) !== "");
  return (
    <select
      ref={ref}
      value={value}
      className={cn(
        "h-10 px-3 pr-8 rounded-md bg-bridge-surface/70 border border-bridge-border/70",
        "text-sm text-bridge-fg outline-none focus:border-bridge-accent/60 focus:shadow-ring",
        "appearance-none cursor-pointer",
        className,
        filterActive && FILTER_ACTIVE_CLASS,
      )}
      {...rest}
    >
      {placeholder && (
        <option value="" className="bg-bridge-panel">
          {placeholder}
        </option>
      )}
      {options.map((o) => (
        <option key={o.value} value={o.value} className="bg-bridge-panel">
          {o.label}
        </option>
      ))}
    </select>
  );
});